// import moment from "moment";
import { ru, tr, zhCN, enUS } from 'date-fns/locale';
import { format, isToday as isTodayFn } from 'date-fns';
import { getCurrentLanguage } from "@utils/lang";
import { TDimensions } from '@api/apiClient';

const locales = {
  cn: zhCN,
  en: enUS,
  ru: ru,
  tr: tr,
};

interface Weight {
  unit: string;
  value: number;
}

export enum localesByLang {
  en="en-US",
  cn="cn-CN",
  tr="tr-TR",
  ru="ru-RU",
}

export function formatNumber(value: string | number) {
  const currentLanguage = getCurrentLanguage();
  return Intl.NumberFormat(localesByLang[currentLanguage]).format(+value);
}


/**
 * Округляет денежную сумму до 2 знаков после запятой, убирая
 * погрешность вычислений с плавающей точкой (например 63.099999999999994 -> 63.1).
 */
export function roundMoney(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function isToday(value?: string | Date) {
  if (!value) return false;
  return isTodayFn(new Date(value));
}

export function weightKg(weight?: Weight): string {
  if (!weight) return "—"
  const res = ({
    'g': 0.001,
    'kg': 1,
  }[weight.unit] || 1) * weight.value;
  if (!res) return "—";
  return formatNumber(res) ?? "—";
}

export function weightKgValue(weight?: Weight): number {
  if (!weight) return 0
  return ({
    'g': 0.001,
    'kg': 1,
  }[weight.unit] || 1) * weight.value;
}


export function weightGValue(weight?: Weight): number {
  if (!weight) return 0
  return (({
    'g': 1,
    'kg': 1000,
  }[weight.unit] || 1) * weight.value);
}

export function formatDate(value: string | Date | undefined | null, dateFormat: string): string {
  if (!value) return ""
  const currentLanguage = getCurrentLanguage();
  return format(value, dateFormat, { locale: locales[currentLanguage] })
  // return moment(value).locale('ru').format(dateFormat);
}

export function formatSumWithCurrency(
  value: string | number | undefined,
  currency: string,
): string {
  if (typeof value === "undefined") return ""
  const v = (typeof value === "string") ? value : (formatNumber(value));
  return `${v} ${getCurrency(currency)}`;
}

export function formatSumFromObject(sumObj?: {
  amount: string | number,
  currency: string,
}): string {
  if (!sumObj) return "";
  const { amount, currency } = sumObj;
  if (!amount) return "";
  const v = (typeof amount === "string") ? amount : (formatNumber(amount));
  return `${v} ${getCurrency(currency)}`;
}

const currencies: Record<string, string> = {
  EUR: "€",
  USD: "$",
  CNY: "¥",
  RUB: "₽",
  TRY: "TRY",
}

export function getCurrency(code: string) {
  return currencies[code] ?? code;
}

export function createSumFromObject(object?: { amount: string | number; currency: string }): string {
  if (!object) return '';
  const { amount, currency } = object;
  const value = (typeof amount === 'string') ? amount : (formatNumber(amount));
  return `${value} ${getCurrency(currency)}`;
}

export function createDimensionsStr(object?: TDimensions): string {
  if (!object) return '—';
  const { height, length, width } = object;
  return `${length.value} / ${width.value} / ${height.value}`;
}
